// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"ProductsListingWidget_skeleton___OFun","useFade-fadeIn":"ProductsListingWidget_useFade-fadeIn__BCido","useFade-fadeOut":"ProductsListingWidget_useFade-fadeOut__LUjwc"};